import { Smartphone } from "lucide-react";

interface MobileAppBadgesProps {
  className?: string;
}

export function MobileAppBadges({ className = "" }: MobileAppBadgesProps) {
  // TODO: Update with actual App Store and Play Store URLs when available
  const APP_STORE_URL = "https://apps.apple.com/app/ezrecipebox/id123456789";
  const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.ezrecipebox.app";

  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Smartphone className="h-4 w-4" />
        <span>Get the mobile app for the best experience</span>
      </div>
      <div className="flex flex-wrap gap-3">
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="transition-opacity hover:opacity-80"
        >
          <img
            src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1728000000"
            alt="Download on the App Store"
            className="h-12"
          />
        </a>
        <a
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="transition-opacity hover:opacity-80"
        >
          <img
            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
            alt="Get it on Google Play"
            className="h-[70px] -my-[11px] -ml-[10px]"
          />
        </a>
      </div>
    </div>
  );
}
